import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import { getAccountIds } from '../ducks/billing';
import {
    closeItemAssignmentDialog,
    isFetching,
    isItemAssignmentDialogOpened,
    getItemAssignmentDialogBillId,
    getItemAssignmentOrderItemIds,
} from '../ducks/itemAssignment';
import { getOrderedAccountIds } from '../selectors';
import { BillingMode } from '../constants';

interface StateProps {
    active: boolean;
    loading: boolean;
    accountIds: string[];
    billId: string;
    orderItemIds?: string[];
    billingMode: BillingMode;
}

interface DispatchProps {
    close(): void;
}

interface GroupOwnProps {
    scope: string;
    serviceOrderIds: string[];
}

interface AccountOwnProps {
    scope: string;
}

export const connectGroupItemAssignmentDialog = connect<StateProps, DispatchProps, GroupOwnProps, ApplicationState>(
    createStructuredSelector({
        active: isItemAssignmentDialogOpened,
        billId: getItemAssignmentDialogBillId,
        loading: isFetching,
        accountIds: getOrderedAccountIds,
        orderItemIds: getItemAssignmentOrderItemIds,
        billingMode: () => BillingMode.ReservationBilling,
    }),
    (dispatch: CommanderThunkDispatch, { scope }) => ({
        close: () => dispatch(closeItemAssignmentDialog(scope)),
    })
);

export const connectAccountItemAssignmentDialog = connect<StateProps, DispatchProps, AccountOwnProps, ApplicationState>(
    createStructuredSelector({
        active: isItemAssignmentDialogOpened,
        billId: getItemAssignmentDialogBillId,
        loading: isFetching,
        accountIds: getAccountIds,
        billingMode: () => BillingMode.AccountBilling,
    }),
    (dispatch: CommanderThunkDispatch, { scope }) => ({
        close: () => dispatch(closeItemAssignmentDialog(scope)),
    })
);
